module.exports = __webpack_public_path__ + "static/media/Basic-Host-Distributor.87978c26.png";